export default "__VITE_ASSET__CjDdzQLj__";